var installedModules = {};
var moduleToHandlerMapping = {
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?f941": {
		getter: () => (__webpack_require__.e(49375).then(() => (() => (__webpack_require__(71756))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Frouter%2Fnext%2Frouter": {
		getter: () => (Promise.all([__webpack_require__.e(19901), __webpack_require__.e(72831), __webpack_require__.e(85714), __webpack_require__.e(32966)]).then(() => (() => (__webpack_require__(72831))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Flink%2Fnext%2Flink?2f63": {
		getter: () => (Promise.all([__webpack_require__.e(19901), __webpack_require__.e(95270)]).then(() => (() => (__webpack_require__(95270))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fscript%2Fnext%2Fscript?b1ec": {
		getter: () => (Promise.all([__webpack_require__.e(85714), __webpack_require__.e(44545)]).then(() => (() => (__webpack_require__(44545))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fimage%2Fnext%2Fimage": {
		getter: () => (Promise.all([__webpack_require__.e(88209), __webpack_require__.e(85714)]).then(() => (() => (__webpack_require__(88209))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fdynamic%2Fnext%2Fdynamic?ed7a": {
		getter: () => (__webpack_require__.e(56749).then(() => (() => (__webpack_require__(56749))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Fjsx-runtime%2Freact%2Fjsx-runtime": {
		getter: () => (__webpack_require__.e(46593).then(() => (() => (__webpack_require__(62540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Freact": {
		getter: () => (__webpack_require__.e(46593).then(() => (() => (__webpack_require__(63696))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fstyled-jsx%2Fstyled-jsx": {
		getter: () => (__webpack_require__.e(17071).then(() => (() => (__webpack_require__(17071))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fstyled-jsx%2Fstyle%2Fstyled-jsx%2Fstyle": {
		getter: () => (__webpack_require__.e(71314).then(() => (() => (__webpack_require__(71314))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact-dom%2Fclient%2Freact-dom%2Fclient": {
		getter: () => (__webpack_require__.e(46593).then(() => (() => (__webpack_require__(7470))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact-dom%2Freact-dom": {
		getter: () => (__webpack_require__.e(46593).then(() => (() => (__webpack_require__(78325))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fdynamic%2Fnext%2Fdynamic?0198": {
		getter: () => (__webpack_require__.e(56749).then(() => (() => (__webpack_require__(56749))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~15.1.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Flink%2Fnext%2Flink?039c": {
		getter: () => (__webpack_require__.e(95270).then(() => (() => (__webpack_require__(95270))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~15.1.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?6979": {
		getter: () => (__webpack_require__.e(71756).then(() => (() => (__webpack_require__(71756))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~15.1.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?c715": {
		getter: () => (__webpack_require__.e(71756).then(() => (() => (__webpack_require__(71756))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^8.1.1-canary.54 || >=9.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fscript%2Fnext%2Fscript?b140": {
		getter: () => (__webpack_require__.e(66926).then(() => (() => (__webpack_require__(44545))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~15.1.9",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	}
};
var initialConsumes = ["webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?f941","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Frouter%2Fnext%2Frouter","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Flink%2Fnext%2Flink?2f63","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fscript%2Fnext%2Fscript?b1ec","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fimage%2Fnext%2Fimage","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fdynamic%2Fnext%2Fdynamic?ed7a","webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Fjsx-runtime%2Freact%2Fjsx-runtime","webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Freact","webpack%2Fsharing%2Fconsume%2Fdefault%2Fstyled-jsx%2Fstyled-jsx","webpack%2Fsharing%2Fconsume%2Fdefault%2Fstyled-jsx%2Fstyle%2Fstyled-jsx%2Fstyle","webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Fjsx-runtime%2Freact%2Fjsx-runtime","webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Freact","webpack%2Fsharing%2Fconsume%2Fdefault%2Freact-dom%2Fclient%2Freact-dom%2Fclient","webpack%2Fsharing%2Fconsume%2Fdefault%2Freact-dom%2Freact-dom","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fdynamic%2Fnext%2Fdynamic?0198","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Flink%2Fnext%2Flink?039c","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Frouter%2Fnext%2Frouter","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?6979","webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?c715"];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"38792": [
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Fjsx-runtime%2Freact%2Fjsx-runtime",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Freact",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact-dom%2Fclient%2Freact-dom%2Fclient",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact-dom%2Freact-dom"
	],
	"55527": [
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?f941",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Frouter%2Fnext%2Frouter",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Flink%2Fnext%2Flink?2f63",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fscript%2Fnext%2Fscript?b1ec",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fimage%2Fnext%2Fimage",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fdynamic%2Fnext%2Fdynamic?ed7a",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Fjsx-runtime%2Freact%2Fjsx-runtime",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact%2Freact",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fstyled-jsx%2Fstyled-jsx",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fstyled-jsx%2Fstyle%2Fstyled-jsx%2Fstyle"
	],
	"69320": [
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?c715"
	],
	"85714": [
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Freact-dom%2Freact-dom"
	],
	"88814": [
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fscript%2Fnext%2Fscript?b140"
	],
	"90636": [
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fdynamic%2Fnext%2Fdynamic?0198",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Flink%2Fnext%2Flink?039c",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Frouter%2Fnext%2Frouter",
		"webpack%2Fsharing%2Fconsume%2Fdefault%2Fnext%2Fhead%2Fnext%2Fhead?6979"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}